module.exports = __webpack_public_path__ + "static/media/myneeds.b482f5cd.svg";